import { render, staticRenderFns } from "./SystemBaseForm.vue?vue&type=template&id=10c8a5ff&"
import script from "./SystemBaseForm.vue?vue&type=script&lang=js&"
export * from "./SystemBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports